import { message } from 'antd'
import React, { useState } from 'react'

import requests from '../../../../../../axios/requests'
import Button from '../../../../../../components/Button/Button'
import ModalWelcome from '../../../../../../pages/Auth/ModalWelcome/ModalWelcome'

import variableLanguage from '../../../../../../../utils/hookGetVariablesLanguage'
import useTimer from '../../../../../../../utils/hooks/useTimer'
import PrevButton from '../../../../../../components/PrevButton/PrevButton'

function AuthMail({ setToggleHeaderFoter, sessionId }) {
  const variables_66 = variableLanguage({
    keyPage: 'authorization',
    keyVariable: 'variables_66',
  })
  const variables_67 = variableLanguage({
    keyPage: 'authorization',
    keyVariable: 'variables_67',
  })
  const variables_68 = variableLanguage({
    keyPage: 'authorization',
    keyVariable: 'variables_68',
  })
  const variables_69 = variableLanguage({
    keyPage: 'authorization',
    keyVariable: 'variables_69',
  })
  const variables_70 = variableLanguage({
    keyPage: 'authorization',
    keyVariable: 'variables_70',
  })
  const { timeLeft, isFinished, isRunning, start, pause, resume, reset } = useTimer(60, () => {
    console.log('Таймер завершен!')
  })

  const [step, setStep] = useState(1)
  const [valueEmailCode, setValueEmailCode] = useState('')
  const [name, setName] = useState('')
  const [image, setImage] = useState('')
  const [valueEmail, setEmail] = useState('')
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  const inputConfirmHandlerEmail = (e) => {
    setEmail(e.target.value.trim().toLowerCase())
  }
  const inputConfirmHandlerEmailCode = (e) => {
    setValueEmailCode(e.target.value)
  }

  const loginHandlerEmail = (e) => {
    e.preventDefault()
    if (!emailPattern.test(valueEmail)) {
      message.warn(variables_66)
      return
    }
    requests.auth
      .verify_email({ email: valueEmail, mode: 'login' })
      .then(() => {
        setToggleHeaderFoter(false)
        setStep(2)
        reset()
        start()
      })
      .catch((error) => {
        let messageDetail
        if (error.response && error.response.data && error.response.data.detail) {
          messageDetail = error.response.data.detail
          message.warn(messageDetail)
        } else if (error.detail) {
          messageDetail = error.detail
          message.warn(messageDetail)
        } else {
          messageDetail = variables_68
          message.warn(messageDetail)
        }
      })
  }
  const loginHandlerEmailCode = (e) => {
    e.preventDefault()
    requests.users
      .validate_sms({
        code: valueEmailCode,
        email: valueEmail,
      })
      .then((response) => {
        if (response.status === 203) {
          console.log('status203')
          message.warn(variables_69)
          return
        }

        setStep(3)

        setName(response.data.name)
        setImage(response.data.avatar)

        if (response.data?.user_exists) {
          // если неаутентифицированный пользователь просматривал страницу, то редирект его на эту страницу.
          if (window.localStorage.getItem('previous_course_link')) {
            window.localStorage.setItem('token', response.data.auth_token)
            window.localStorage.setItem('username', response.data.name)
            window.localStorage.setItem('last_name', response.data.last_name)
            window.localStorage.setItem('middle_name', response.data.middle_name)
            window.location.href = window.localStorage.getItem('previous_course_link')
            setTimeout(() => {
              window.localStorage.removeItem('previous_course_link')
            }, 1000)
            return
          }

          window.localStorage.setItem('token', response.data.auth_token)
          window.localStorage.setItem('username', response.data.name)
          window.localStorage.setItem('last_name', response.data.last_name)
          window.localStorage.setItem('middle_name', response.data.middle_name)
        } else {
          console.log('иначе вернуть куда то там')
        }
      })
      .catch((error) => {
        console.error(error)
        message.warn(variables_69)
      })
  }
  return (
    <div>
      {step === 1 && (
        <>
          <input
            className="auth-item input"
            value={valueEmail}
            onChange={inputConfirmHandlerEmail}
            placeholder={variables_66}
          />
          <Button
            text={variables_67}
            click={loginHandlerEmail}
            zIndex={3}
            className={'AuthFormBtn'}
            margin="20px 0"
          />
        </>
      )}
      {step === 2 && (
        <>
          <PrevButton click={() => setStep(1)} />
          <input
            className="auth-item input"
            value={valueEmailCode}
            onChange={inputConfirmHandlerEmailCode}
            placeholder={variables_68}
            maxLength={4}
          />
          {!isFinished ? (
            <div className="auth-item_timer">Осталось {timeLeft} секунд</div>
          ) : (
            <div className="auth-item_again_code" onClick={loginHandlerEmail}>
              Код не пришел? <span>&nbsp;Получить код снова</span>
            </div>
          )}
          <Button
            text={variables_70}
            click={loginHandlerEmailCode}
            zIndex={3}
            className={'AuthFormBtn'}
            margin="20px 0"
          />
        </>
      )}
      {step === 3 && (
        <ModalWelcome image={image} name={name} setImage={setImage} sessionId={sessionId} />
      )}
    </div>
  )
}

export default AuthMail
